import { type ReactElement, useCallback } from 'react'

import { useCtaTracking } from '@lib/hooks/use-cta-tracking'

import { ComponentCtaButtonType } from '@constants/enums/cta'

import { type CtaProps } from '@components/cta/cta-prop-types'
import { Button } from '@components/ui-core/button/button'

import { useProductCta } from '../use-product-cta'

export function GrammarlyCtaButton(props: CtaProps): ReactElement {
  const { url, text } = useProductCta(ComponentCtaButtonType.Grammarly)
  const { isCompact, category = 'primary', ...restProps } = props
  const { trackAndNavigate, isLoading } = useCtaTracking({ placement: 'Section' })

  const onClickHandler = useCallback(async () => {
    trackAndNavigate(
      ComponentCtaButtonType.Grammarly,
      text,
      category === 'unstyled' ? 'text' : category,
      url,
    )
  }, [text, category, url, trackAndNavigate])

  return (
    <Button
      category={category}
      onClick={onClickHandler}
      isCompact={isCompact}
      isLoading={isLoading}
      text={text}
      href={url}
      {...restProps}
    />
  )
}
